// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2fWLy","title":"BackImages_title__INDe5","images":"BackImages_images__1UtJz"};